import { AppTenant, UserPermissionRole } from '@retail/auth/types';
import { OrgUnitAssortment, OrgUnitType } from '@retail/mgpris/config-types';

interface SelectedOrgUnitSource extends OrgUnitAssortment {
  isSuperUser: boolean;
  appTenant: AppTenant;
}

export interface SelectedOrgUnitAssortmentProps {
  name: string;
  assortmentId: number;
  draftAssortmentId: number;
  orgUnitId: number;
  isSuperUser: boolean;
  orgType: OrgUnitType;
  appTenant: AppTenant;
  latitude?: number;
  longitude?: number;
  userRole: UserPermissionRole;
}
export class SelectedOrgUnit {
  name: string;
  assortmentId: number;
  draftAssortmentId: number;
  orgUnitId: number;
  isSuperUser: boolean;
  orgType: OrgUnitType;
  appTenant: AppTenant;
  latitude?: number;
  longitude?: number;
  userRole: UserPermissionRole;

  private constructor(props: SelectedOrgUnitAssortmentProps) {
    this.name = props.name;
    this.assortmentId = props.assortmentId;
    this.draftAssortmentId = props.draftAssortmentId;
    this.orgUnitId = props.orgUnitId;
    this.isSuperUser = props.isSuperUser;
    this.orgType = props.orgType;
    this.appTenant = props.appTenant;
    this.latitude = props.latitude;
    this.longitude = props.longitude;
    this.userRole = props.userRole;
  }

  static fromOrgUnitAssortment = ({
    name,
    assortmentId,
    draftAssortmentId,
    orgUnitType,
    grantedOrgUnitId,
    isSuperUser,
    appTenant,
    latitude,
    longitude,
  }: SelectedOrgUnitSource): SelectedOrgUnit => {
    return new SelectedOrgUnit({
      name,
      assortmentId,
      orgUnitId: grantedOrgUnitId,
      draftAssortmentId,
      isSuperUser,
      appTenant,
      latitude,
      longitude,
      userRole: isSuperUser ? 'SUPERUSER' : 'ADMIN',
      orgType: orgUnitType,
    });
  };
}

export interface SelectedOrgUnitState {
  assortmentId: number;
  orgUnitType: OrgUnitType;
  isBrandContext: boolean;
  isPriceListContext: boolean;
  appTenant: AppTenant;
  selectedUserAssortment: OrgUnitAssortment;
  selectedOrgUnitAssortment: SelectedOrgUnit;
  selectOrgUnitAssortment: (assortmentId: number) => void;
}
